import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { useDispatch, useSelector } from 'react-redux';
import CalcType from 'state/Constants/CalcType';
import { DELETE_DEFINITION } from './actions';
import { selectDefinitions, selectFetchingData } from './selectors';
import SelectionState from 'state/selections/SelectionState';

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const {issuerCountType, calcType, key} = definition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      };
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `Issuer Count ${issuerCountType} - Acc`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `Issuer Count ${issuerCountType} - Rel`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `Issuer Count ${issuerCountType} - Bench`;
          columnDef.loading = fetchingAbsData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }
      columnDefs.push(columnDef);
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, fetchingRelData]);
};